import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const EditButton = ({ isClaimed, onClick, content }) => {
  if (isClaimed) {
    return (
      <Button
        size="medium"
        icon="lock"
        fluid
        content="locked for demo"
        disabled
      />
    );
  }

  return (
    <Button
      size="medium"
      basic
      fluid
      content={content}
      onClick={onClick}
    />
  );
};

EditButton.propTypes = {
  isClaimed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
};

export default EditButton;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/edit-button.js
 **/